import { createAsyncThunk } from '@reduxjs/toolkit';
import { setLedgerData, setLoading, setSearchResults, setLoadingSearch } from './supplierLedgerSlice';
import { getCreditorLedgerApi } from '../../../apiservice/reports';
import { getAccountBySeachApi } from '../../../apiservice/setting';

export const fetchSupplierLedger = createAsyncThunk(
    'supplierLedger/fetchSupplierLedger',
    async (payload, { dispatch, getState }) => {
        try {
            dispatch(setLoading(true));

            const response = await getCreditorLedgerApi({
                supplierId: payload.supplierId,
                dateFrom: payload.fromDate,
                dateTo: payload.toDate,
            });

            if (response.data) {
                dispatch(setLedgerData(response.data));

                const supplierResponse = await getAccountBySeachApi({
                    query: '',
                    type: 'creditor',
                    acc_id: payload.supplierId
                });

                if (supplierResponse.data && supplierResponse.data.length > 0) {
                    dispatch(setLedgerData({
                        ...response.data,
                        supplier: supplierResponse.data[0]
                    }));
                }
            }

            return response.data;
        } catch (error) {
            console.error('Error fetching supplier ledger:', error);
            throw error;
        } finally {
            dispatch(setLoading(false));
        }
    }
);

export const searchSuppliers = createAsyncThunk(
    'supplierLedger/searchSuppliers',
    async (searchTerm, { dispatch, getState }) => {
        try {
            dispatch(setLoadingSearch(true));

            const response = await getAccountBySeachApi({
                query: searchTerm.trim(),
                type: "creditor",
            });

            dispatch(setSearchResults(response.data || []));
            return response.data;
        } catch (error) {
            console.error('Error searching suppliers:', error);
            throw error;
        } finally {
            dispatch(setLoadingSearch(false));
        }
    }
);